import { UserIcon } from "@app/design-system/icons";
import { EntityIdentityRow } from "@app/features/shared/EntityIdentityRow";

export type CustomerIdentityRowProps = {
  name: string;
  size?: number
};

/**
 * Customer's "icon + name" row — shared by Home's `TrackingHeader` (below
 * its logo/order-code row) and the Customer Details page (as its own
 * grouped section). Not `CustomerInfoRow` (Order Details' bigger
 * icon/label/badge card) — a distinct, simpler shape. Thin wrapper around
 * `EntityIdentityRow` fixing the icon to the Customer glyph, same as
 * `ServiceDetailsPage` fixes it to `service.icon`.
 */
export const CustomerIdentityRow = ({ name , size=20 }: CustomerIdentityRowProps) => (
  <EntityIdentityRow icon={<UserIcon size={size} />} name={name} />
);
